import { useMutation } from 'react-query';
import { MonitorQueueAPI } from '../../constants/API';
import { getMonitorToken } from '../../constants/HeadersAPI';
import axios from 'axios';

export const useUpdateSoundStatus = () => {
  const {
    mutate: updateSoundStatus,
    isLoading,
    isError
  } = useMutation(
    ['soundStatus'],
    (id: number | null) => {
      const token = getMonitorToken();
      const url = token
        ? `${MonitorQueueAPI.putSoundStatus(id!)}?token=${token}`
        : MonitorQueueAPI.putSoundStatus(id!);
      return axios.put(url, '');
    },
    {}
  );

  return { updateSoundStatus, isLoading, isError };
};
